import React, { useEffect, useState } from 'react'
import { ClockCircleOutlined } from '@ant-design/icons'
import { Alert, Timeline } from 'antd'
import axiosInstance from '../../api/utils/axiosInstance'
import moment from 'moment'

export const YearPlanDeadlineDetails = () => {
  
    const [mainDeadline, setMainDeadline] = useState(["",""]);
    const [additionalDeadline, setAdditionalDeadline] = useState(["",""]);

    useEffect(() => {
        const fetch = async() => {
            try{
                const res = await axiosInstance.get("/organizer/deadlines");
                setMainDeadline(res.data.mainPlanDeadline);
                setAdditionalDeadline(res.data.additionalPlanDeadline);
            }catch(e){
                console.log(e);
            }
        }
        fetch();
    },[]);

    const renderTimeline = (dealdines) => {
        return <>
            {moment(mainDeadline[0]).format("DD.MM.YYYY.")} - {moment(mainDeadline[1]).format("DD.MM.YYYY.")}
        </>
    }
  
    return (
    <div>
    <Timeline mode="left">
        <Timeline.Item label={renderTimeline(mainDeadline)} dot={<ClockCircleOutlined style={{fontSize: '16px',}}/>} color="red">
            Rok za podnošenje godišnjeg plana
        </Timeline.Item>
        <Timeline.Item label={renderTimeline(additionalDeadline)} dot={<ClockCircleOutlined style={{fontSize: '16px',}}/>} color="red">
            Rok za podnošenje dodatnog pojedinačnog plana
        </Timeline.Item>
    </Timeline>
    <div>
        <Alert showIcon message="Godišnji plan se uvijek dostavlja za slijedeću godinu" type="info"/>
        <Alert showIcon message="Mogućnost kreiranja dodatnog pojedinačnog plana, ovisi o postojanju godišnji plan za istu godinu" />
        <Alert showIcon message="Planove je moguće dostaviti samo u gore navedenom roku" type="warning"/>
    </div>
    </div>
  )
}
